var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Accordion_1;
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { array, arrayOf, bool, element, eventListener, object, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AbortableCloseEvent, CloseEvent, OpenEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { classNames, getSlot, isFunction, propagateData } from '@philips-internal/oswald-ui-utils';
import { CollapseArrow } from '../collapse-arrow/collapse-arrow.js';
import { AccordionAPI } from './accordion-api.js';
import './accordion.css';
const AccordionHeaderContainer = {
    acceptedTypes: [
        ComponentType.BEHAVIOR,
        ComponentType.DATA_DISPLAY,
        ComponentType.LAYOUT,
    ],
    name: 'header',
};
const AccordionContentContainer = {
    acceptedTypes: [
        ComponentType.AGGREGATOR,
        ComponentType.BEHAVIOR,
        ComponentType.DATA_DISPLAY,
        ComponentType.FORM,
        ComponentType.LAYOUT,
        ComponentType.LIST,
    ],
    name: 'content',
};
let Accordion = Accordion_1 = class Accordion extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            collapsed: true,
        };
        this.onClick = () => {
            const { onBeforeClose, onClose, onOpen } = this.props;
            const { collapsed } = this.state;
            let aborted = false;
            if (isFunction(onBeforeClose) && !collapsed) {
                const abort = () => { aborted = true; };
                onBeforeClose(new AbortableCloseEvent({ abort }));
            }
            if (aborted) {
                return;
            }
            const fn = () => {
                const { collapsed } = this.state;
                if (collapsed) {
                    isFunction(onClose) && onClose(new CloseEvent());
                }
                else {
                    isFunction(onOpen) && onOpen(new OpenEvent());
                }
            };
            this.setState((prevState) => ({ collapsed: !prevState.collapsed }), fn);
        };
        this.getClassName = () => {
            const { className } = this.props;
            const classes = {
                'c-accordion': true,
                [`${className}`]: Boolean(className),
            };
            return classNames(classes);
        };
    }
    componentDidMount() {
        const { initialCollapsed } = this.props;
        if (typeof initialCollapsed !== 'undefined') {
            this.setState({ collapsed: initialCollapsed });
        }
    }
    componentDidUpdate(prevProps) {
        const { initialCollapsed = Accordion_1.defaultProps.initialCollapsed } = this.props;
        const { initialCollapsed: prevInitialCollapsed } = prevProps;
        if (initialCollapsed !== prevInitialCollapsed) {
            this.setState({ collapsed: initialCollapsed });
        }
    }
    renderHeader() {
        const { children, data, uuid = Accordion_1.defaultProps.uuid } = this.props;
        const { collapsed } = this.state;
        const content = getSlot(children, 'header');
        return (React.createElement("div", { className: "c-accordion__header" },
            React.createElement(Container, { acceptedTypes: AccordionHeaderContainer.acceptedTypes, className: "c-accordion__container", onClick: this.onClick, slot: AccordionHeaderContainer.name, uuid: uuid }, propagateData(content, data)),
            React.createElement(CollapseArrow, { collapsed: collapsed, onClick: this.onClick })));
    }
    renderContent() {
        const { collapsed } = this.state;
        if (collapsed) {
            return null;
        }
        const { children, data, uuid = Accordion_1.defaultProps.uuid } = this.props;
        const content = getSlot(children, 'content');
        return (React.createElement(Container, { acceptedTypes: AccordionContentContainer.acceptedTypes, className: "c-accordion__content", slot: AccordionContentContainer.name, uuid: uuid }, propagateData(content, data)));
    }
    render() {
        return (React.createElement("div", { className: this.getClassName(), "data-testid": "accordion" },
            this.renderHeader(),
            this.renderContent()));
    }
};
Accordion.propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    className: string,
    data: oneOfType([array, object]).notEnumerable(),
    initialCollapsed: bool,
    onClose: eventListener,
    onOpen: eventListener,
    uuid: string,
};
Accordion.defaultProps = {
    initialCollapsed: true,
    uuid: '',
};
Accordion = Accordion_1 = __decorate([
    AwesomeComponent({ api: AccordionAPI, containers: [AccordionHeaderContainer, AccordionContentContainer], type: ComponentType.AGGREGATOR })
], Accordion);
export { Accordion, AccordionHeaderContainer, AccordionContentContainer, };
export default Accordion;
//# sourceMappingURL=accordion.js.map